import { useState } from "react";

export default function Service() {
  const [openIndex, setOpenIndex] = useState(0);

  const services = [
    {
      number: "01",
      title: "Personal Branding",
      description: (
        <>
          We help individuals shine authentically -
          <br className="hidden sm:block" />
          building powerful personal brands that inspire
          <br className="hidden sm:block" /> trust, influence, and recognition.
        </>
      ),
    },
    {
      number: "02",
      title: "Public Relations",
      description: (
        <>
          We craft compelling narratives and strategic
          <br className="hidden sm:block" /> media relations that keep our clients in the
          <br className="hidden sm:block" /> spotlight for all the right reasons.
        </>
      ),
    },
    {
      number: "03",
      title: "Branding",
      description: (
        <>
          From idea to identity, we create brands that
          <br className="hidden sm:block" /> connect emotionally, stand out visually,
          <br className="hidden sm:block" /> and speak with purpose.
        </>
      ),
    },
    {
      number: "04",
      title: "Environmental Branding",
      description: (
        <>
          We transform spaces into brand experiences
          <br className="hidden sm:block" />
          bringing your story to life through visuals,
          <br className="hidden sm:block" />
          ambiance, and design that speak volumes.
        </>
      ),
    },
    {
      number: "05",
      title: "Events",
      description: (
        <>
          From concept to execution, we design
          <br className="hidden sm:block" />
          experiences that engage, excite, and leave
          <br className="hidden sm:block" /> lasting impressions.
        </>
      ),
    },
    {
      number: "06",
      title: "Consulting",
      description: (
        <>
          We guide businesses and personalities with
          <br className="hidden sm:block" /> strategic insight helping them position, grow,
          <br className="hidden sm:block" /> and stay relevant in a fast-evolving world.
        </>
      ),
    },
  ];

  return (
    <section className="py-24 w-full">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0">

        {/* Heading */}
        <p className="text-center font-bold mb-16 text-xl sm:text-2xl uppercase tracking-[0.2em]">
          Our Services
        </p>

        {/* Services list */}
        <div className="flex flex-col">
          {services.map((service, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className="group transition-all duration-700 ease-in-out"
                onMouseEnter={() => setOpenIndex(i)}
              >

                {/* --- MOBILE VIEW --- */}
                <div className="sm:hidden border border-black rounded-[2.5rem] p-8 mb-6">
                  <div
                    className="text-gray-200 font-bold tracking-tighter"
                    style={{ fontSize: "80px", lineHeight: "1" }}
                  >
                    {service.number}
                  </div>
                  <h3 className="font-bold text-black text-2xl mt-6 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    {service.description}
                  </p>
                </div>

                {/* --- DESKTOP VIEW --- */}
                <div
                  className={`hidden sm:flex items-center border-t border-gray-200 overflow-hidden transition-all duration-700 ease-in-out ${
                    i === services.length - 1 ? "border-b" : ""
                  }`}
                  style={{
                    height: isOpen ? "100vh" : "110px",
                    paddingLeft: "2rem",
                    paddingRight: "2rem",
                  }}
                >
                  {/* Giant number */}
                  <div
                    className={`select-none flex-shrink-0 transition-all duration-700 ease-in-out ${
                      isOpen ? "text-black" : "text-gray-200"
                    }`}
                    style={{
                      fontSize: isOpen ? "clamp(180px, 22vw, 400px)" : "clamp(80px, 8vw, 100px)",
                      lineHeight: 1,
                      width: "45%",
                      fontWeight: 800,
                    }}
                  >
                    {service.number}
                  </div>

                  {/* Right side: title + description */}
                  <div className="flex flex-col justify-center flex-1 transition-all duration-700 pl-12 lg:pl-20">
                    <h3
                      className="font-bold text-black transition-all duration-700"
                      style={{
                        fontSize: isOpen ? "clamp(32px, 4vw, 72px)" : "clamp(20px, 2vw, 28px)",
                        lineHeight: 1.1,
                      }}
                    >
                      {service.title}
                    </h3>

                    <div
                      className={`overflow-hidden transition-all duration-1000 delay-150 ${
                        isOpen ? "max-h-[500px] opacity-100 mt-10" : "max-h-0 opacity-0 mt-0"
                      }`}
                    >
                      <p className="text-gray-800 text-lg lg:text-2xl leading-relaxed max-w-xl">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}